import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getHistory } from "@/lib/api";
import { historyKindLabel, historyPath, historyStatusLabel, normalizeHistory } from "@/lib/history";

const when = (iso) => { try { return new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "short" }); } catch { return ""; } };

// Cross-product timeline (M11). A failed request is an error, never an empty list that looks like "no activity".
export default function RecentActivity({ limit = 5 }) {
  const [state, setState] = useState({ status: "loading", items: [] });
  useEffect(() => {
    let alive = true;
    getHistory({ limit }).then((payload) => { if (alive) setState({ status: "ready", items: normalizeHistory(payload) }); })
      .catch(() => { if (alive) setState({ status: "error", items: [] }); });
    return () => { alive = false; };
  }, [limit]);
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="recent-activity">
      <h2 className="font-heading text-lg font-semibold text-slate-900">Aktivitas terbaru</h2>
      {state.status === "loading" && <p className="mt-2 text-sm text-slate-500" data-testid="activity-loading">Memuat…</p>}
      {state.status === "error" && <p className="mt-2 text-sm text-amber-700" role="alert" data-testid="activity-error">Aktivitas tidak dapat dimuat saat ini.</p>}
      {state.status === "ready" && state.items.length === 0 && <p className="mt-2 text-sm text-slate-500" data-testid="activity-empty">Belum ada aktivitas. Mulai dengan membuat video jualan.</p>}
      {state.items.length > 0 && (
        <ul className="mt-3 divide-y divide-slate-100">
          {state.items.map((item) => {
            const path = historyPath(item);
            const body = <><span className="text-xs text-slate-500">{historyKindLabel(item.kind)}</span><span className="block truncate text-sm text-slate-900">{item.title}</span></>;
            return (
              <li key={`${item.kind}:${item.id}`} className="flex items-center justify-between gap-3 py-2" data-testid={`activity-${item.kind}-${item.id}`}>
                <div className="min-w-0">{path ? <Link to={path} className="hover:underline">{body}</Link> : body}</div>
                <div className="shrink-0 text-right text-xs"><span className="font-medium text-slate-700">{historyStatusLabel(item.status)}</span><span className="block text-slate-400">{when(item.created_at)}</span></div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
